<script lang="ts" setup>
import { useAccountMenu } from '@/composables/useAccountMenu'
import store from '@/store'

/** App-bar menu item showing the user's name and email; links to the profile page. */
const { studentFullName } = useAccountMenu()
</script>

<template>
  <v-list-item to="/profile">
    <v-list-item-title>{{ studentFullName }}</v-list-item-title>
    <v-list-item-subtitle>{{ store.getters.user.user?.email }}</v-list-item-subtitle>
    <template #append>
      <v-icon>mdi-pencil</v-icon>
    </template>
  </v-list-item>
</template>
